import { memo } from 'react'
import { Box, Grid } from '@/components/Layout'
import { Modal } from '@/components/Surface'
import { useTranslations } from '@/core/translation'
import { currencies } from '../CurrencySelector.data'
import { CurrencyModalProps } from './CurrencyModal.types'
import { useCurrencyModalController } from './CurrencyModal.controller'
import { currencyModalStyles as styles } from './CurrencyModal.style'
import CurrencyOption from './CurrencyOption'

function CurrencyModal(props: CurrencyModalProps) {
  const { open } = props
  const t = useTranslations('sidebar')
  const { selected, onSelect, onConfirmClick, onCancel } = useCurrencyModalController(props)

  return (
    <Modal
      open={open}
      onClose={onCancel}
      showCloseIcon
      showTitleOnTop
      title={t('currency.title')}
      containerStyles={styles.container}
      actionButtonProps={{
        topBordered: true,
        wrapperProps: { sx: styles.actionsWrapper },
        primaryActionText: t('currency.confirm'),
        onPrimaryActionClick: onConfirmClick,
        primaryButtonProps: { fullWidth: true, size: 'small', sx: styles.confirmButton },
        secondaryActionText: t('currency.cancel'),
        onSecondaryActionClick: onCancel,
        secondaryButtonProps: {
          fullWidth: true,
          size: 'small',
          variant: 'outlined',
          color: 'secondary',
          sx: styles.cancelButton,
        },
      }}>
      <Box sx={styles.list}>
        <Grid container spacing={1.5}>
          {currencies.map((option) => (
            <Grid size={6} key={option.code}>
              <CurrencyOption
                option={option}
                isSelected={option.code === selected}
                onSelect={onSelect}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Modal>
  )
}

export default memo(CurrencyModal)
